<template>
  <modal name="vitrineEdit" height="auto" width="900" :lazy="true" :scrollable="true" :clickToClose="true">
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="row">
          <ul class="tabs">
            <li class="tab-active">
              <a @click="() => {}">Editar Vitrine</a>
            </li>
          </ul>
        </div>
        <div class="form">
          <div class="alert remover" v-show="!!errorMessage">
            <a href="#" class="close" @click="errorMessage = null">&times;</a>
            Falha ao Salvar alterações:<br>
            <p>{{ errorMessage }}</p>
          </div>
          <div class="row">
            <div class="col-2-3">
              <div class="row">
                <div class="col-2-3">
                  <div class="form-group">
                    <label>Título</label>
                    <input class="form-control" v-model="item.titulo" maxlength="25"/>
                    <div class="message">{{ validation.firstError('item.titulo') }}</div>
                  </div>
                </div>
                <div class="col-1-3">
                  <div class="form-group">
                    <label>Ativo</label>
                    <select class="form-control" v-model="item.ativo">
                      <option :value="true">Sim</option>
                      <option :value="false">Não</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-1-3">
                  <div class="form-group">
                    <label>Tag no Produto</label>
                    <input class="form-control" v-model="item.tag_produto" maxlength="30"/>
                    <div class="message">{{ validation.firstError('item.tag_produto') }}</div>
                  </div>
                </div>
                <div class="col-1-3">
                  <div class="form-group">
                    <label>Ordem</label>
                    <input class="form-control" v-model="item.ordem" maxlength="30" type="number"/>
                    <div class="message">{{ validation.firstError('item.ordem') }}</div>
                  </div>
                </div>
                <div class="col-1-3" v-if="item.coluna">
                  <div class="form-group">
                    <label>Coluna View</label>
                    <input class="form-control" :value="item.coluna.toUpperCase()" disabled/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-1">
                  <div class="form-group">
                    <label>Slug (Exibição na URL)</label>
                    <input class="form-control" v-model="item.slug"/>
                    <div class="message">{{ validation.firstError('item.slug') }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-1-3">
              <div class="form-group">
                <label>Cor</label>
                <ColorPicker
                  :onChange="changeColor"
                  :value="item.cor"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-actions">
          <button type="button" :class="{ 'button button-success button-lg': true, 'button-disabled': validation.hasError() }" v-on:click="handleSubmit()">
            Salvar
          </button>
          <button type="button" class="button button-lg" v-on:click="close">Fechar</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import SimpleVueValidation from "simple-vue-validator";
  import ColorPicker from '../../components/ColorPicker'

  const Validator = SimpleVueValidation.Validator.create({
    templates: {
      required: "Campo de preenchimento obrigatório"
    }
  });

  export default {
    name: "vitrinesEdit",
    components: {
      ColorPicker
    },
    props: [
      "onClose",
      "onSubmit",
      "item",
      "close"
    ],
    data() {
      return {
        errorMessage: null,
        colorPicker: {
          colors: '#000'
        }
      };
    },
    validators: {
      'item.titulo': (value) => Validator.value(value).required(),
      'item.cor': (value) => Validator.value(value).required(),
      'item.tag_produto': (value) => Validator.value(value).required(),
      'item.ordem': (value) => Validator.value(value).required(),
      'item.coluna': (value) => Validator.value(value).required(),
      'item.slug': (value) => Validator.value(value).required(),
    },

    methods: {
      handleSubmit() {
        this.$validate()
          .then(success => {
            if (success) {
              this.onSubmit(this.item)
                .catch((error) => {
                  this.errorMessage = error.message
                })
            }
          })
      },
      changeColor(cor) {
        this.item.cor = cor
      }
    },
  };

</script>



// WEBPACK FOOTER //
// src/views/Vitrines/Edit.vue